import { render, staticRenderFns } from "./LiveTab.vue?vue&type=template&id=02a0280c&scoped=true"
import script from "./LiveTab.vue?vue&type=script&lang=js"
export * from "./LiveTab.vue?vue&type=script&lang=js"
import style0 from "./LiveTab.vue?vue&type=style&index=0&id=02a0280c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a0280c",
  null
  
)

export default component.exports